import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingWhatsapp"] */ "/vercel/path0/src/components/floating-whatsapp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/src/components/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Journey"] */ "/vercel/path0/src/components/journey.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MapLocation"] */ "/vercel/path0/src/components/map-location.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMedia"] */ "/vercel/path0/src/components/social-media.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/src/components/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScheduledAppointment"] */ "/vercel/path0/src/components/ui/scheduled-appointment.tsx");
